module.exports = __webpack_public_path__ + "static/media/159.229b1e55.jpg";